import { getOpeningHours } from "./get-opening-hours.js";
import { getSpecialOpeningHours } from "./get-special-opening-hours.js";
const getOpeningHoursSpecification = (store) => {
  return [...getOpeningHours(store), ...getSpecialOpeningHours(store.specialOpeningHours ?? [])];
};
export {
  getOpeningHoursSpecification
};
//# sourceMappingURL=get-opening-hours-specification.js.map
